import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { ErrorService } from '../services/generic-error/error.service';
import { AccessPermissionsService } from '../services/access-permissions/access-permissions.service';
import { withCatchErrorSideEffects } from '../utils/rxjs-operators/with-catch-error-side-effects';
import { AlmostThereResponse } from '../../common/dtos/access-permissions.dto';
import utils from '../utils/account-permission/account-permission.util';
import { LoggerService } from '../services/logger/logger.service';

@Injectable({
    providedIn: 'root',
})
export class AlmostThereResolver {
    private store = inject(Store);
    private accessPermissionsService = inject(AccessPermissionsService);
    private errorService = inject(ErrorService);
    private loggerService = inject(LoggerService);


    resolve(route: ActivatedRouteSnapshot): Observable<AlmostThereResponse> {
        const token = route.queryParams['token'] ? route.queryParams['token'] : route.params.token;
        return this.accessPermissionsService.markGranteeAsLiteRegistered(token).pipe(
            tap((data: AlmostThereResponse) =>
                utils.handleAccessTypeAndClientTypeUpdate(
                    data,
                    this.store,
                    this.errorService,
                    true,
                ),
            ),
            withCatchErrorSideEffects(this.errorService, this.loggerService),
        );
    }
}
